import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a294d93f2dfc9fe146ffb74c931b9526ab from "./generated-2a1200f7-9f1c-4101-b241-80db52f91cc0.json";

import ad49cf5c3358f9aae3ed8dbb9d58e42abb from "./generated-8310fe33-a6cb-4d8d-a5dc-d8030209119a.json";

import af50fa08b553ed5d462896e108c4d317eb from "./generated-75423c9e-f916-4f47-825c-33cd23230f67.json";

import a36bff9c9ca995234212e406da1456370b from "./generated-1315d019-0577-47a0-b7c6-4f8a5015101e.json";

import aba10e1633301096d9970139051939fecb from "./generated-330e555f-ea47-47a4-9a4b-00ef1414a805.json";

import a2de936f8bb0448170f847c55eb1d6bd4b from "./generated-6755ed68-5a77-4468-9844-5c7c98542db7.json";

import a131a066ebf8614c5619e419a9839a33eb from "./generated-eaece2c5-0ef4-4abd-825d-92645c777799.json";

import ad671830b910b8be75868ae81093550a0b from "./generated-88bf3226-0e2b-42dc-8013-4fbccd2167ac.json";

import a3753894e707b263d794521f6c9f20957b from "./generated-ae70c2c6-bc97-4a91-9647-a364c819240b.json";

import a9c1a0d0555378c021b19a12d41d12d0eb from "./generated-bfed047c-a010-4b0d-a0ad-abad44cdd29e.json";

import a7e758308ea429a3f934164f0fcd92676b from "./generated-aeaaa4a0-d4a0-4560-864c-7527b75fccf3.json";

import a0db47b43cc78d0225ca4a495e18b6e34b from "./generated-db3e9627-a119-4844-a95e-4085d44ec66e.json";

import a1a1f7c63eb9e1e17db05c5905e3c5428b from "./generated-642e4b5d-b88a-4765-902f-1ae868eaf5ac.json";

import a4c2b80473481fa8ec37bf9e6ab767b1bb from "./generated-90406bf4-a520-4c6b-9bb5-5eb56e0163e6.json";

import af2f558f949e73f8ffe0898da674b8136b from "./generated-4bf297ff-3cb6-47c2-880d-bc5a6821f333.json";

import af607454397d6f2a950b0d42eb7e3f00db from "./generated-49e2aace-4f17-49bf-80c8-4547dcc98485.json";

import ae547b3408c1ed06aa2618fca91170235b from "./generated-690f3d0e-8678-4065-a286-5dd0ff427626.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a294d93f2dfc9fe146ffb74c931b9526ab);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(ad49cf5c3358f9aae3ed8dbb9d58e42abb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(af50fa08b553ed5d462896e108c4d317eb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a36bff9c9ca995234212e406da1456370b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(aba10e1633301096d9970139051939fecb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a2de936f8bb0448170f847c55eb1d6bd4b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a131a066ebf8614c5619e419a9839a33eb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(ad671830b910b8be75868ae81093550a0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a3753894e707b263d794521f6c9f20957b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a9c1a0d0555378c021b19a12d41d12d0eb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a7e758308ea429a3f934164f0fcd92676b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a0db47b43cc78d0225ca4a495e18b6e34b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a3753894e707b263d794521f6c9f20957b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a1a1f7c63eb9e1e17db05c5905e3c5428b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a4c2b80473481fa8ec37bf9e6ab767b1bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a3753894e707b263d794521f6c9f20957b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(af2f558f949e73f8ffe0898da674b8136b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(af607454397d6f2a950b0d42eb7e3f00db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(ae547b3408c1ed06aa2618fca91170235b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(af2f558f949e73f8ffe0898da674b8136b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */